import React, { useContext } from "react";
import {
  Alert,
  Backdrop,
  Box,
  Button,
  CircularProgress,
  IconButton,
  InputAdornment,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
// import { ArrowBackIos } from "@mui/icons-material";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { UserInfo } from "../../components/context";
import { Lock, Mail, Visibility, VisibilityOff } from "@mui/icons-material";

const LoginUsingEmail = ({ close, tab }) => {
  const [openPasswordInvalid, setOpenPasswordInvalid] = React.useState(false);
  const [errorMsg, setErrorMsg] = React.useState("");
  const [isProcess, setIsProcess] = React.useState(false);
  const { handleRerunUser } = useContext(UserInfo);
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = React.useState(false);

  const handleGetUser = (e) => {
    e.persist();
    e.preventDefault();
    var formdata = new FormData(e.target);
    setIsProcess(true);
    axios
      .post("email/login", formdata)
      .then((response) => {
        const data = response.data;
        if (data.message === "user-invalid") {
          setErrorMsg("Invalid Credentials!");
          setOpenPasswordInvalid(true);
        }
        if (data.message === "success") {
          setTimeout(() => {
            sessionStorage.setItem("_hns_token", data.token);
            handleRerunUser();
            navigate("/");
            navigate(0);
          }, 1000);
        }
        setIsProcess(false);

        // if (data.message === "account-invalid") {
        //   setErrorMsg("Invalid Credentials!");
        //   setOpenPasswordInvalid(true);
        //   setIsProcess(false);
        // } else {
        //   setTimeout(() => {
        //     setIsProcess(false);
        //     setTimeout(() => {
        //       localStorage.setItem("estherToken", data.access_token);
        //       // close();
        //       handleRerunUser();
        //       navigate("/");
        //       navigate(0);
        //       // if (tab !== null && tab === "landingpage") {
        //       //   localStorage.setItem("template", "admin_page");
        //       //   setTimeout(() => {
        //       //     navigate("/");
        //       //     navigate(0);
        //       //   }, 200);
        //       // }
        //     }, 500);
        //   }, 1000);
        // }
      })
      .catch((error) => {
        setIsProcess(false);
        console.log("error", error);
      });
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <Box
        sx={{
          width: "100%",
          height: `calc(100vh - 64px)`,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            // border: "1px solid red",
            height: "100%",
            // border: "1px solid blue",
          }}
        >
          <Box
            sx={{
              width: "100%",
              maxWidth: 280,
              border: "1px solid #e5e5e5",
              padding: 2,
              borderRadius: 5,
            }}
          >
            <form onSubmit={handleGetUser}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  mb: 4,
                }}
              >
                <Typography
                  variant="h5"
                  // sx={{ fontFamily: "Futura Md Bt", fontWeight: 700 }}
                >
                  Welcome Back!
                </Typography>
              </Box>
              <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
                <TextField
                  InputLabelProps={{
                    shrink: true,
                  }}
                  label="Email"
                  fullWidth
                  placeholder="Email"
                  name="email"
                  required
                  // margin="dense"
                  size="small"
                  InputProps={{
                    // Add the toggle button as an adornment at the end of the input field
                    startAdornment: (
                      <InputAdornment position="start">
                        <Mail />
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>
              <Box sx={{ display: "flex", justifyContent: "center", mb: 1 }}>
                <TextField
                  InputLabelProps={{
                    shrink: true,
                  }}
                  label="Password"
                  fullWidth
                  name="password"
                  type={showPassword ? "text" : "password"}
                  placeholder="•••••••"
                  required
                  // margin="dense"
                  size="small"
                  InputProps={{
                    // Add the toggle button as an adornment at the end of the input field
                    startAdornment: (
                      <InputAdornment position="start">
                        <Lock />
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => {
                            setShowPassword(
                              (prevShowPassword) => !prevShowPassword
                            );
                          }}
                          onMouseDown={(event) => event.preventDefault()} // Prevents text selection when clicking
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>
              {/* <Box sx={{ display: "flex", mb: 2 }}>
                <Typography sx={{ fontSize: 12, textDecoration: "underline" }}>
                  Forgot Password?
                </Typography>
              </Box> */}
              <Box
                sx={{ display: "flex", justifyContent: "center", mb: 2, mt: 2 }}
              >
                <Button
                  sx={{
                    // color: "#fff",
                    // textTransform: "none",
                    // fontWeight: 700,
                    // height: 40,
                    backgroundColor:
                      process.env.REACT_APP_APP_NAME === "estherph"
                        ? "#261138"
                        : "#ff9f1d",
                    // borderRadius: 2,
                  }}
                  fullWidth
                  size="large"
                  type="submit"
                  disabled={isProcess}
                  // variant="contained"
                >
                  <Typography
                    variant="subtitle2"
                    // fontFamily={"Futura Md Bt"}
                    sx={{
                      // fontWeight: 700,
                      color: "#fff",
                    }}
                  >
                    Login
                  </Typography>
                </Button>
              </Box>
              {/* <Box sx={{ display: "flex", justifyContent: "center", mb: 4 }}>
                <Button
                  sx={{
                    color: "#000",
                    textTransform: "none",
                    fontWeight: 700,
                    height: 40,
                    //   backgroundColor: "#2264f6",
                    borderRadius: 2,
                  }}
                  fullWidth
                  size="small"
                  onClick={() => {
                    localStorage.removeItem("estherRedirect");
                    // close();
                    navigate("/");
                  }}
                >
                  <ArrowBackIos sx={{ fontSize: "12px ", color: "#AEAEAE" }} />
                  <Typography
                    variant="subtitle2"
                    fontFamily={"Futura Md Bt"}
                    sx={{
                      fontWeight: 700,
                    }}
                  >
                    Back
                  </Typography>
                </Button>
              </Box> */}
            </form>
          </Box>
        </Box>
      </Box>

      <Snackbar
        open={openPasswordInvalid}
        autoHideDuration={3000}
        onClose={(event, reason) => {
          if (reason === "clickaway") {
            return;
          }
          setOpenPasswordInvalid(false);
        }}
      >
        <Alert
          onClose={(event, reason) => {
            if (reason === "clickaway") {
              return;
            }
            setOpenPasswordInvalid(false);
          }}
          severity="error"
          sx={{ width: "100%" }}
        >
          {errorMsg}
        </Alert>
      </Snackbar>

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isProcess}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress color="inherit" size={70} />
          <Typography sx={{ mt: 2 }}>Loading...</Typography>
        </Box>
      </Backdrop>
    </Box>
  );
};

export default LoginUsingEmail;
